export enum Interval {
    Hour = 0,
    Day = 1,
    Week = 7,
    Month = 30,
    ThreeMonths = 90,
}
